import {omit} from 'lodash';

/**
 * Rename figure to panel (updating old workspaces format/naming)
 * @param workspaces: Array of workspaces
 * @returns Array of workspaces
 */
export function updateWorkspaceFormat(workspaces) {
  return workspaces.map(workspace => {
    const panels = (workspace.panels ? workspace.panels : workspace.figures) || [];
    return {...omit(workspace, ['figures']), panels};
  });
}

/**
 * Get the component (type) of a panel.
 *
 * The panel component can be used e.g. in templates ':is=component'
 * @param panel: panel object
 * @returns String of panel component
 */
export function getPanelComponent(panel) {
  switch (panel.type) {
    case 'model':
      return 'model-panel';
    case 'info':
      return 'info-panel';
    case 'timeseries':
      return 'timeseries-panel';
    case 'text':
      return 'text-panel';
    default:
      switch (panel.options.showAs) {
        case 'text':
          return 'text-panel';
        default:
          return 'timeseries-panel';
      }
  }
}
